<template>
  <div>
    <v-card class="mx-auto mt-4" max-width="95%" elevation="2">
      <v-overlay :value="loading" absolute opacity="0.7">
        <v-progress-circular indeterminate size="48" />
      </v-overlay>
      <v-toolbar color="#37474F" dark>
        <v-toolbar-title>하우스 애드 · 보상 타입 관리</v-toolbar-title>
        <v-spacer />
        <v-btn color="white" outlined @click="openRegistDialog" :disabled="loading">
          <v-icon left>mdi-plus</v-icon>
          보상 타입 등록
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-0">
        <v-data-table
          v-if="rewardTypes.length > 0"
          :headers="headers"
          :items="rewardTypes"
          :items-per-page="15"
          class="elevation-0"
          hide-default-footer
        >
          <template v-slot:item.name="{ item }">
            <span class="font-weight-medium">{{ item.name || '-' }}</span>
          </template>
          <template v-slot:item.quantity="{ item }">
            <span class="text-body-2">{{ item.quantity || 0 }}</span>
          </template>
          <template v-slot:item.actions="{ item, index }">
            <v-btn icon small @click="openEditDialog(index)">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon small @click="removeRewardType(index)">
              <v-icon small color="error">mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>

        <v-container v-if="rewardTypes.length === 0" class="text-center py-8">
          <v-icon size="64" color="grey lighten-1">mdi-gift-outline</v-icon>
          <p class="text-body-1 grey--text mt-3">등록된 보상 타입이 없습니다. '보상 타입 등록'으로 추가하세요.</p>
          <p class="text-caption grey--text">보상 타입을 등록하여 관리할 수 있습니다.</p>
        </v-container>
      </v-card-text>
    </v-card>

    <!-- 보상 타입 등록/수정 다이얼로그 -->
    <v-dialog v-model="dialog" max-width="960" scrollable>
      <v-card>
        <v-card-title>{{ editIndex >= 0 ? '보상 타입 수정' : '보상 타입 등록' }}</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="form.name"
            label="보상 타입 이름"
            outlined
            dense
            hide-details
            class="mb-3"
            placeholder="예: 채굴기 100코인"
          />
          <v-text-field
            v-model.number="form.quantity"
            label="수량"
            type="number"
            outlined
            dense
            hide-details
            class="mb-3"
            placeholder="0"
            min="0"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog = false">취소</v-btn>
          <v-btn color="primary" @click="saveRewardType">저장</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const defaultForm = () => ({
  name: '',
  quantity: 0,
});

export default {
  name: 'HouseAd_RewardType',
  data: () => ({
    dialog: false,
    editIndex: -1,
    form: defaultForm(),
    loading: false,
    headers: [
      { text: '이름', value: 'name', width: '200' },
      { text: '수량', value: 'quantity', width: '100' },
      { text: '액션', value: 'actions', width: '100', sortable: false, align: 'center' },
    ],
  }),
  computed: {
    rewardTypes() {
      return this.$store.state.housead_reward_types || [];
    },
  },
  mounted() {
    this.loadHouseAd();
  },
  methods: {
    loadHouseAd() {
      this.loading = true;
      this.$store.dispatch('HOUSEAD_FETCH_CMS_INIT')
        .catch((err) => {
          alert(err && err.message ? err.message : '하우스 애드 데이터를 불러오지 못했습니다.');
        })
        .finally(() => { this.loading = false; });
    },
    openRegistDialog() {
      this.editIndex = -1;
      this.form = defaultForm();
      this.dialog = true;
    },
    openEditDialog(index) {
      this.editIndex = index;
      const item = this.rewardTypes[index];
      this.form = {
        name: item.name || '',
        quantity: item.quantity || 0,
      };
      this.dialog = true;
    },
    saveRewardType() {
      if (!this.form.name || !this.form.name.trim()) {
        alert('보상 타입 이름을 입력해주세요.');
        return;
      }
      const payload = {
        name: this.form.name.trim(),
        quantity: Number(this.form.quantity) || 0,
      };
      const isEdit = this.editIndex >= 0;
      if (isEdit) payload.id = this.rewardTypes[this.editIndex].id;
      this.loading = true;
      const action = isEdit ? 'HOUSEAD_UPDATE_REWARD_TYPE' : 'HOUSEAD_CREATE_REWARD_TYPE';
      const payloadArg = isEdit ? { index: this.editIndex, item: payload } : { item: payload };
      this.$store.dispatch(action, payloadArg)
        .then(() => { this.dialog = false; })
        .catch((err) => { alert(err && err.message ? err.message : '저장에 실패했습니다.'); })
        .finally(() => { this.loading = false; });
    },
    removeRewardType(index) {
      if (!confirm('이 보상 타입을 삭제하시겠습니까?')) return;
      this.loading = true;
      this.$store.dispatch('HOUSEAD_DELETE_REWARD_TYPE', { index })
        .catch((err) => { alert(err && err.message ? err.message : '삭제에 실패했습니다.'); })
        .finally(() => { this.loading = false; });
    },
  },
};
</script>
